import { Form } from 'react-bootstrap';
import DatePicker from 'react-datetime';

export default ({ label, disabled, placeholder, ...props }) => {
  return (
    <Form.Group className="mb-4">
      <Form.Label>{label}</Form.Label>
      <DatePicker
        inputProps={{
          className: 'form-control',
          placeholder,
          disabled,
        }}
        timeFormat={false}
        closeOnSelect
        dateFormat="MM/DD/YYYY"
        {...props}
      />
    </Form.Group>
  );
};
